import {PAYMENT_METHODS} from './payment-methods.constant';

export const PaymentOptions =
    [
        {
            "id": PAYMENT_METHODS.FASTER_PAYMENT_SYSTEM,
            "name": "pagePaymentAndContact.fps.fps",
            "icon": "assets/images/payment/fps.svg",
            "selected": false,
            "country": "HKG"
        },
        {
            "id": PAYMENT_METHODS.DUITNOW,
            "name": "pagePaymentAndContact.duitNow.duitNow",
            "icon": "assets/images/payment/duitnow.svg",
            "selected": false,
            "country": "MYS"
        },
        {
            "id": PAYMENT_METHODS.BANK_TRANSFER,
            "name": "pagePaymentAndContact.bankAcct.bankTransfer",
            "icon": "assets/images/payment/bank.svg",
            "selected": false,
            "country": "HKG,MYS"
        },
        {
            "id": PAYMENT_METHODS.PAYNOW,
            "name": "pagePaymentAndContact.paynow.paynow",
            "icon": "assets/images/payment/paynow.svg",
            "selected": false,
            "country": "SGP"
        },
        {
            "id": PAYMENT_METHODS.BANK_TRANSFER,
            "name": "pagePaymentAndContact.bankAcct.bankTransferSGP",
            "icon": "assets/images/payment/bank.svg",
            "selected": false,
            "country": "SGP"
        }

    ];
